const searchResultDefault = {
  data: [],
  total: 0,
}

export default searchResultDefault;
